import { render } from "./PromptProgress.vue?vue&type=template&id=17272041&scoped=true"
import script from "./PromptProgress.vue?vue&type=script&lang=js"
export * from "./PromptProgress.vue?vue&type=script&lang=js"

import "./PromptProgress.vue?vue&type=style&index=0&id=17272041&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-17272041"

export default script